import React from "react";
import { Select, FormControl, InputLabel, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    marginLeft: "5px",
    marginTop: "16px",
    marginBottom: "8px",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function TypeFilter(props) {
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl}>
      <InputLabel shrink>Order Type</InputLabel>
      <Select
        value={props.value}
        onChange={props.onChange}
        displayEmpty
        className={classes.selectEmpty}
        inputProps={{ "aria-label": "Without label" }}
      >
        <MenuItem value={""}>All</MenuItem>
        <MenuItem value={1}>Delivery</MenuItem>
        <MenuItem value={2}>Pick-Up</MenuItem>
      </Select>
    </FormControl>
  );
}

export default TypeFilter;
